import React from 'react';
import { Box, BoxExtendedProps } from '@common-fe/common-fe';
import styled from 'styled-components';

import { useStore } from '@/modules/core/components/Sidebar/store/useSidebarStore';

interface FixedWrapperProps {
  isScrolled?: boolean;
  isMinified?: boolean;
}
const FixedWrapper = styled(Box)<FixedWrapperProps>`
  position: fixed;
  right: 0;
  left: ${({ isMinified }) => (isMinified ? '88px' : '272px')};
  top: 0;
  z-index: 1001;
`;

interface Props extends BoxExtendedProps {
  children?: React.ReactNode;
}
const FixedTopWrapper: React.FC<Props> = ({ children, as, ...rest }) => {
  const minify = useStore((state) => state.minify);
  return (
    <FixedWrapper background="canvas" isMinified={minify} {...rest}>
      {children}
    </FixedWrapper>
  );
};

export default FixedTopWrapper;
